import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import Carousel from "react-material-ui-carousel";
import IconButton from "@mui/material/IconButton";
import CloseSharp from "@mui/icons-material/CloseSharp";
import { useTheme } from "@mui/material";
import productBGeffect from "../../assets/images/productBGeffect.webp";
import { Link } from "react-router-dom";

const ProductDetail = ({ product, open, onClose }) => {
  const theme = useTheme();
  var image = product.image.split(",").map((img) => {
    let imageUrl;
    try {
      imageUrl = require(`../../assets/images/products${img}`);
    } catch (error) {
      imageUrl = require("../../assets/images/products/default.webp"); // default image
    }
    return imageUrl;
  });

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      PaperProps={{
        style: {
          minWidth: "70vw",
          borderRadius: "25px",
          maxHeight: "90vh",
        },
      }}
    >
      <IconButton
        aria-label="close"
        onClick={onClose}
        style={{
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        }}
      >
        <CloseSharp />
      </IconButton>
      <DialogContent
        sx={{
          backgroundImage: `url(${productBGeffect})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          overflow: "auto",
          [theme.breakpoints.up("md")]: {
            overflow: "hidden",
          },
        }}
      >
        <div className="flex flex-col md:flex-row justify-between align-middle my-4 font-jost text-gray-800">
          {/* Image Carousel Section */}
          <div className="w-full md:w-1/2 pb-1 md:p-4 max-h-[85vh] sticky content-center">
            <Carousel
              indicators={false}
              sx={{
                maxHeight: "65vh",
                borderRadius: "20px",
                contain: "content",
              }}
            >
              {image.map((image, index) => (
                <div
                  key={index}
                  style={{
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={image}
                    alt={`Product ${index}`}
                    style={{
                      maxHeight: "100%",
                      maxWidth: "100%",
                      objectFit: "contain",
                    }}
                  />
                </div>
              ))}
            </Carousel>
            <div
              onClick={onClose}
              className="rounded-lg text-center mx-auto px-2 md:px-6 py-1 md:py-3 bg-[#FFC700]"
            >
              <Link to="/contactus">Place Order</Link>
            </div>
          </div>
          <div className="w-[1px] mx-5 md:my-[30vh] bg-slate-800"></div>
          <div className="w-[1px] md:my-[40vh] bg-slate-800"></div>
          <div
            className="w-full h-full md:w-2/3 md:px-8 pb-10"
            style={{
              maxHeight: "85vh",
              overflowY: "auto",
              scrollbarWidth: "thin",
              scrollbarColor: "#888 transparent",
            }}
          >
            <div className="flex justify-end">
              <Button
                variant="contained"
                sx={{
                  paddingX: 2,
                  paddingY: 1,
                  backgroundColor: "#AABBBE",
                  color: "#4E5B5E",
                  borderRadius: 3,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  lineHeight: "normal",
                  height: "100%",
                  "&:hover": {
                    backgroundColor: "#AABBBE",
                    boxShadow: "none",
                  },
                }}
              >
                {product.category}
              </Button>
            </div>

            <h2 className="text-2xl md:text-5xl font-bold mb-2 font-jost py-2">
              {product.Name}
            </h2>

            <hr className="border-t-2 border-black" />

            <div className="py-3">
              <h3 className="text-lg md:text-2xl font-bold pb-1">Size</h3>
              <div className="flex flex-row">{product.Specifications.Size}</div>
            </div>

            <div className="text-lg md:text-2xl font-bold">Description</div>

            <p className="mb-3 text-sm md:text-base">{product.Description}</p>

            <hr className="border-t-2 border-black" />

            <div className="md:p-1 mt-4 text-sm md:text-base">
              {Object.entries(product.Specifications)
                .filter(([key]) => key !== "Size")
                .map(([key, value]) => (
                  <div
                    key={key}
                    className="flex justify-between mb-2 text-right font-jost"
                  >
                    <strong>{key}:</strong> {value}
                  </div>
                ))}
            </div>

            <div
              onClick={onClose}
              className="md:w-1/4 rounded-lg text-center mx-auto px-6 py-3 bg-[#050606] text-white font-HNthin tracking-widest cursor-pointer"
            >
              Close
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ProductDetail;
